import { useQuery } from "@tanstack/react-query";
import { fetchEcommMultiChannel } from "../services/multiChannelEcommService";

export function useEcommMultiChannel(period: number) {
  return useQuery({
    queryKey: ["ecomm-shopify", period],
    queryFn: () => fetchEcommMultiChannel(period),
    staleTime: 1000 * 60 * 5, // 5 mins
  });
}
